import { Injectable } from "@nestjs/common";
import { CoLineRequest, CommonResponseModel, PVHCoLinereqModel, PVHColorModel, PVHDestinationModel, PVHSizeModel, PvhCompareModel, PvhOrderDataModel, PvhOrderFilter, PvhSizeWiseModel, StatusEnum } from "@project-management-system/shared-models";
import * as fs from 'fs';
import * as nodemailer from 'nodemailer';
import * as path from 'path';
import * as puppeteer from 'puppeteer';
import { DataSource, In } from "typeorm";
import { GenericTransactionManager } from "../../typeorm-transactions";
import { AddressService } from "../Entites@Shahi/address/address-service";
import { ColorRepository } from "../Entites@Shahi/color/color-repo";
import { SizeRepository } from "../Entites@Shahi/size/size-repo";
import { OrderDetailsReq } from "../ralph-lauren/dto/order-details-req";
import { ItemNoDtos } from "../sanmar/dto/sanmar-item-no.dto";
import { PvhCOLineEntity } from "./entities/pvh-co-line.entity";
import { PvhOrderschildEntity } from "./entities/pvh-orders-child.entity";
import { PVHOrdersEntity } from "./entities/pvh-orders.entity";
import { PvhPdfInfoEntity } from "./entities/pvh-pdf.entity";
import { PvhCOLineRepository } from "./repositories/pvh-co-line.repository";
import { PvhOrdersChildRepository } from "./repositories/pvh-orders-child.repo";
import { PVHOrdersRepository } from "./repositories/pvh-orders.repo";
import { PvhPdfRepo } from "./repositories/pvh-pdf.repo";
import { Cron } from "@nestjs/schedule";
const { Builder, Browser, By, Select, until } = require('selenium-webdriver');
const moment = require('moment');
const { URL } = require('url')
const ftp = require('basic-ftp');
const util = require('util');

@Injectable()
export class PVHService {
  constructor(
    private dataSource: DataSource,
    private PvhOrdersRepo: PVHOrdersRepository,
    private PvhOrdersChildRepo: PvhOrdersChildRepository,
    private pvhPdfRepo: PvhPdfRepo,
    private pvhCoLineRepo: PvhCOLineRepository,
    private addressService: AddressService,
    private colorRepo: ColorRepository,
    private sizeRepo: SizeRepository


  ) { }

  async savePvhOrder(req: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction();
      await transactionManager.getRepository(PVHOrdersEntity).delete({ poNumber: req.poNumber });
      await transactionManager.getRepository(PvhOrderschildEntity).delete({ poNumber: req.poNumber });
      let saved;
      const pdfData = [];
  
      for (const item of req.PvhpoItemDetails) {
        for (const variant of item.PvhpoItemVariantDetails) {
          const entity = new PVHOrdersEntity();
          entity.poNumber = req.poNumber;
          entity.currency = req.currency;
          entity.buyerName = req.buyerName;
          entity.buyerSaveName = req.buyerSaveName;
          entity.deliveryAddress = req.deliveryAddress;
          entity.buyerAddress = req.buyerAddress;
          entity.totalQuantity = req.totalQuantity;
          entity.division = req.division;
          entity.orderValue = req.orderValue;
          entity.poLine = item.poLine;
          entity.incoterm = item.incoterm;
          entity.deliveryDate = item.deliveryDate;
          entity.exFactoryDate = item.exFactoryDate;
          entity.transMode = item.transMode;
          entity.shortDescription = item.shortDescription;
          entity.gender = item.gender;
          entity.portOfLoading = item.portOfLoading;
          entity.line = variant.line;
          entity.plmStyle = variant.plmStyle;
          entity.size = variant.size;
          entity.dimensions = variant.dimensions;
          entity.sizeDescription = variant.sizeDescription;
          entity.color = variant.color;
          entity.upc = variant.upc;
          entity.quantity = variant.quantity;
          entity.unitPrice = variant.unitPrice;
          entity.status = StatusEnum.OPEN;
          pdfData.push(entity);
          saved = await transactionManager.getRepository(PVHOrdersEntity).save(entity);
          if (!saved) {
            throw new Error('Save failed for PVHOrdersEntity');
          }
          const entitys = new PvhOrderschildEntity();
          entitys.poNumber = req.poNumber;
          entitys.currency = req.currency;
          entitys.buyerName = req.buyerName;
          entitys.buyerSaveName = req.buyerSaveName;
          entitys.deliveryAddress = req.deliveryAddress;
          entitys.buyerAddress = req.buyerAddress;
          entitys.totalQuantity = req.totalQuantity;
          entitys.division = req.division;
          entitys.orderValue = req.orderValue;
          entitys.poLine = item.poLine;
          entitys.incoterm = item.incoterm;
          entitys.deliveryDate = item.deliveryDate;
          entitys.exFactoryDate = item.exFactoryDate;
          entitys.transMode = item.transMode;
          entitys.shortDescription = item.shortDescription;
          entitys.gender = item.gender;
          entitys.portOfLoading = item.portOfLoading;
          entitys.line = variant.line;
          entitys.plmStyle = variant.plmStyle;
          entitys.size = variant.size;
          entitys.dimensions = variant.dimensions;
          entitys.sizeDescription = variant.sizeDescription;
          entitys.color = variant.color;
          entitys.upc = variant.upc;
          entitys.quantity = variant.quantity;
          entitys.unitPrice = variant.unitPrice;
          entitys.status = StatusEnum.OPEN;
          entitys.orderId = entity.id;
          const savedChild = await transactionManager.getRepository(PvhOrderschildEntity).save(entitys);
  
          if (!savedChild) {
            throw new Error('Save failed for PvhOrderschildEntity');
          }
        }
      }
  
      await transactionManager.completeTransaction();
      return new CommonResponseModel(true, 1, 'Data saved successfully', saved);
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Failed', err.message || 'Error Occured while Order saving');
    }
  }
  
  async updatePath(req: any, jsonData: any, poNumber: any, orderValue: any, buyerName: any): Promise<CommonResponseModel> {
    try {

      let flag = true;
      const entities = []
      for (const res of req) {
        const entity = new PvhPdfInfoEntity();
        entity.pdfFileName = res.filename
        entity.filePath = res.path
        entity.poNumber = poNumber
        entity.buyerName = buyerName
        entity.orderValue = orderValue
        entity.fileData = jsonData
        entity.fileType = res.mimetype.replace(/text\//g, "")
        entity.createdUser = "admin"
        entity.uploadStatus = "SUCCESS";
        entities.push(entity);
      }
      const uploadDoc = await this.pvhPdfRepo.save(entities);
      if (!uploadDoc) {
        flag = false;
      }
      if (flag) {
        return new CommonResponseModel(true, 11, 'uploaded successfully', req);
      }
      else {
        return new CommonResponseModel(false, 11, 'uploaded failed', req);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  async getorderDataForInfo(req?: PvhOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.PvhOrdersRepo.getorderDataForInfo(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No data Found');
      }
      const sizeDateMap = new Map<string, PvhOrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`)) {
          sizeDateMap.set(
            `${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`,
            new PvhOrderDataModel(rec.id, rec.po_number, rec.delivery_address, rec.trans_mode, rec.currency, rec.po_line, rec.material, rec.total_unit_price, rec.original_date, rec.status, rec.delivery_date, rec.buyer_name, [], rec.plm_style, rec.total_quantity, rec.color, rec.division, rec.gender, rec.short_description, rec.port, rec.order_value, rec.unit_price)
          );

        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`).sizeWiseData;
        const existingSizeData = sizeWiseData.find(item => item.size === rec.size && item.quantity === rec.quantity && item.unitPrice === rec.unit_price);
        if (!existingSizeData && rec.size !== null) {
          sizeWiseData.push(new PvhSizeWiseModel(rec.product, rec.size, rec.upc, rec.planned_ex_factory_date, rec.ex_factory_date, rec.quantity, rec.unit_price, rec.item_no, rec.color));
        }
      }
      const dataModelArray: PvhOrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  // @Cron('2 * * * *')
  // async pvhBot() {
  //   const browser = await puppeteer.launch({ headless: false, args: ['--start-maximized'] });
  //   try {
  //     const page = await browser.newPage();
  //     await page.setViewport({ width: 1580, height: 900 });

  //     await page.goto('http://165.22.220.143/pvh_app/#/login', {
  //       timeout: 100000,
  //       waitUntil: 'networkidle0',
  //     });

  //     await page.waitForSelector('#login-form_username');
  //     await page.type('#login-form_username', 'pvh@gmail.com');

  //     await page.waitForSelector('#login-form_password');
  //     await page.type('#login-form_password', 'pvh');

  //     await page.click('button.ant-btn-primary');
  //     await page.waitForNavigation();

  //     await page.goto('http://165.22.220.143/pvh_app/#/pvh/pvh-pdf-upload', {
  //       timeout: 100000,
  //       waitUntil: 'networkidle0'
  //     });

  //     //live directory paths:
  //     const directoryPath = 'D:/PVH-POs/PVH-Z-New-PO/';
  //     const destinationDirectory = 'D:/PVH-POs/PVH-Z-Read-PO/';

  //     await page.waitForTimeout(4000);
  //     const files = fs.readdirSync(directoryPath);
  //     await page.waitForTimeout(4000);
  //     for (const file of files) {
  //       await page.waitForSelector('input[type="file"]');
  //       const fileInput = await page.$('input[type="file"]');
  //       const filePath = path.join(directoryPath, file);
  //       await fileInput.uploadFile(filePath);
  //       await page.waitForTimeout(3000);

  //       //   await page.waitForSelector('button.ant-btn-primary');
  //       //   await page.click('button.ant-btn-primary');

  //       //   const response = await page.waitForResponse(response => {
  //       //     const contentType = response.headers()['content-type'];
  //       //     return contentType && contentType.includes('application/json');
  //       //   }, { timeout: 0 });
  //       //   if (response.ok()) {
  //       //     await page.waitForTimeout(3000);
  //       //     const sourceFilePath = path.join(directoryPath, file);
  //       //     const destinationFilePath = path.join(destinationDirectory, file);
  //       //     fs.rename(sourceFilePath, destinationFilePath, async (err) => {
  //       //       if (err) {
  //       //         return new CommonResponseModel(false, 0, '');
  //       //       }
  //       //     })
  //       // }
  //       await page.waitForSelector('button.ant-btn-primary');
  //       await page.click('button.ant-btn-primary');

  //       const response = await page.waitForResponse(response => {
  //         const contentType = response.headers()['content-type'];
  //         return contentType && contentType.includes('application/json') && response.ok();
  //       }, { timeout: 0 })

  //       if (response.ok()) {
  //         await page.waitForTimeout(3000);
  //         const sourceFilePath = path.join(directoryPath, file);
  //         const destinationFilePath = path.join(destinationDirectory, file);

  //         fs.rename(sourceFilePath, destinationFilePath, (err) => {
  //           if (err) {
  //             return new CommonResponseModel(false, 0, '');
  //           }
  //         });
  //       }

  //     }
  //   } catch (error) {
  //     return new CommonResponseModel(false, 0, error);
  //   } finally {
  //     await browser.close();
  //   }
  // }

  @Cron('1 * * * *')
  // @Cron('*/5 * * * *')
  async pvhBot() {
    const browser = await puppeteer.launch({
      headless: false,
      args: ['--start-maximized'],
      executablePath: 'C:\\Program Files (x86)\\Microsoft\\Edge\\Application\\msedge.exe'
    });
    try {
      const page = await browser.newPage();
      await page.setViewport({ width: 1580, height: 900 });

      await page.goto('http://165.22.220.143/pvh_app/#/login', {
        timeout: 100000,
        waitUntil: 'networkidle0',
      });

      await page.waitForSelector('#login-form_username');
      await page.type('#login-form_username', 'pvh@gmail.com');

      await page.waitForSelector('#login-form_password');
      await page.type('#login-form_password', 'pvh');

      await page.waitForTimeout(2000);
      await page.click('button.ant-btn-primary');

      await page.goto('http://165.22.220.143/pvh_app/#/pvh/pvh-pdf-upload', {
        timeout: 100000,
        waitUntil: 'networkidle0'
      });

      const directoryPath = 'D:/PVH-POs/PVH-Z-New-PO/';
      const destinationDirectory = 'D:/PVH-POs/PVH-Z-Read-PO/';

      await page.waitForTimeout(4000);
      const files = fs.readdirSync(directoryPath);

      for (const file of files) {
        await page.waitForTimeout(3000);
        await page.waitForSelector('input[type="file"]');
        const fileInput = await page.$('input[type="file"]');
        const filePath = path.join(directoryPath, file);
        await fileInput.uploadFile(filePath);
        await page.waitForTimeout(3000);

        await page.waitForSelector('button.ant-btn-primary');
        await page.click('button.ant-btn-primary');

        const response = await page.waitForResponse(response => {
          const contentType = response.headers()['content-type'];
          return contentType && contentType.includes('application/json') && response.ok();
        }, { timeout: 0 });

        if (response.ok()) {
          await page.waitForTimeout(3000);
          const sourceFilePath = path.join(directoryPath, file);
          const destinationFilePath = path.join(destinationDirectory, file);

          try {
            fs.renameSync(sourceFilePath, destinationFilePath);
          } catch (err) {
            console.error(`Error moving file: ${file}`, err);
            return new CommonResponseModel(false, 0, 'File move error');
          }
        }
      }
    } catch (error) {
      console.error('Error during process', error);
      return new CommonResponseModel(false, 0, error);
    } finally {
      if (browser) {
        await browser.close();
      }
    }
  }

  // @Cron('0 0 5 * * *')
  @Cron('3 * * * *')
  async moveXmlFilesFromFTPToLocal(): Promise<CommonResponseModel> {
    const copyFileAsync = util.promisify(fs.copyFile);
    const unlinkAsync = util.promisify(fs.unlink);
    const readdirAsync = util.promisify(fs.readdir);
    const statAsync = util.promisify(fs.stat);
    try {
      const xmlOutPath = '\\\\172.22.150.13\\pvh-xml\\XML_OUT\\';
      const localPath = 'D:/PVH-POs/PVH-Z-New-PO/';
      const files = await readdirAsync(xmlOutPath);
      const today = new Date();
      const todayDateString = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
      const fileOperations = files.map(async (file) => {
        const filePath = path.join(xmlOutPath, file);
        try {
          const fileStat = await statAsync(filePath);
          const fileModifiedDate = `${fileStat.mtime.getDate().toString().padStart(2, '0')}/${(fileStat.mtime.getMonth() + 1).toString().padStart(2, '0')}/${fileStat.mtime.getFullYear()}`;
          if (fileModifiedDate === todayDateString) {
            const destinationPath = path.join(localPath, file);
            await copyFileAsync(filePath, destinationPath);
            await unlinkAsync(filePath);
            // console.log(`Moved file ${file} to ${destinationPath}`);
          }
        } catch (err) {
          console.error(`Error processing file ${file}:`, err);
        }
      });
      await Promise.all(fileOperations);
      console.log(`${today}All files Moved Successfully`);
      return new CommonResponseModel(true, 1983623663, `${today}All files Moved Successfully`);
    } catch (err) {
      console.error('Error listing or moving files:', err);
    }
  }

  async getPoNumber(req?: any): Promise<CommonResponseModel> {
    try {
      const data = await this.PvhOrdersRepo.getPoNumber(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getorderacceptanceData(req?: PvhOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.PvhOrdersRepo.getorderacceptanceData(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'No data Found');
      }
      const sizeDateMap = new Map<string, PvhOrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_line},${rec.po_number},${rec.delivery_date}`)) {
          sizeDateMap.set(
            `${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`,
            new PvhOrderDataModel(rec.id, rec.po_number, rec.delivery_address, rec.trans_mode, rec.currency, rec.po_line, rec.material, rec.total_unit_price, rec.original_date, rec.status, rec.delivery_date, rec.buyer_name, [], rec.plm_style, rec.total_quantity, rec.color, rec.division, rec.gender, rec.short_description, rec.port, rec.order_value, rec.unit_price, rec.buyer_save_name)
          );
        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_line},${rec.po_number},${rec.delivery_date},${rec.color}`).sizeWiseData;
        const existingSizeData = sizeWiseData.find(item => item.size === rec.size && item.quantity === rec.quantity && item.unitPrice === rec.unit_price);
        if (!existingSizeData && rec.size !== null) {
          sizeWiseData.push(new PvhSizeWiseModel(rec.product, rec.size, rec.upc, rec.planned_ex_factory_date, rec.ex_factory_date, rec.quantity, rec.unit_price, rec.item_no, rec.color));
        }
      }
      const dataModelArray: PvhOrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async getPdfFileInfo(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.pvhPdfRepo.getPdfFileInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getHistoryPoNumber(req?: any): Promise<CommonResponseModel> {
    try {
      const data = await this.pvhPdfRepo.getHistoryPoNumber(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  // async getOrderdataForCOline(req: OrderDetailsReq): Promise<CommonResponseModel> {
  //   console.log(req,"reqqqq")
  //   try {
  //     const poLineValues = req?.poLine;
  //     const data = await this.PvhOrdersRepo.find({ where: { poNumber: req.poNumber, poLine: poLineValues, buyerName:req.buyerName} });

  //     const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string, price: string }[]>>>();
  //     const poMap = new Map<string, PVHOrdersEntity>();

  //     for (const rec of data) {
  //       // poMap.set(`${rec.poNumber}`, rec);
  //       poMap.set(`${rec.poLine},${rec.poNumber}`, rec)
  //       // const parts = rec.deliveryAddress.split(',');
  //       // const destAdd = parts[0].trim();
  //       // const dest = destAdd;
  //       const dest = rec.deliveryAddress

  //       if (!destinationColSizesMap.has(`${rec.poLine},${rec.poNumber}`)) {
  //         destinationColSizesMap.set(`${rec.poLine},${rec.poNumber}`, new Map<string, Map<string, []>>());
  //       }
  //       if (!destinationColSizesMap.get(`${rec.poLine},${rec.poNumber}`).has(dest)) {
  //         destinationColSizesMap.get(`${rec.poLine},${rec.poNumber}`).set(dest, new Map<string, []>());
  //       }

  //       // const colorcheck = await this.colorRepo.findOne({
  //       //   where: {
  //       //     colorCode: rec.material
  //       //   }
  //       // });

  //       // const colorName = colorcheck ? colorcheck.colorName : '';
  //       if (!destinationColSizesMap.get(`${rec.poLine},${rec.poNumber}`).get(dest).has(rec.color)) {
  //         destinationColSizesMap.get(`${rec.poLine},${rec.poNumber}`).get(dest).set(rec.color, []);
  //       }

  //       // const sizecheck = await this.sizeRepo.findOne({
  //       //   where: {
  //       //     poSize: rec.size
  //       //   }
  //       // });

  //       // if (sizecheck) {
  //       //   destinationColSizesMap.get(`${rec.poNumber}`).get(dest).get(colorName).push({ size: sizecheck.crmSize, quantity: rec.quantity, price: rec.unitPrice });
  //       // } else {
  //       destinationColSizesMap.get(`${rec.poLine},${rec.poNumber}`).get(dest).get(rec.color).push({ size: rec.size, quantity: rec.quantity, price: rec.unitPrice });
  //       // }
  //     }

  //     const coData = [];
  //     destinationColSizesMap.forEach((destColorSize, poNumber) => {
  //       const desArray = [];
  //       destColorSize.forEach((colorSizes, dest) => {
  //         const ColArray = [];
  //         colorSizes.forEach((sizes, color) => {
  //           const sizeArray = [];
  //           sizes.forEach((size) => {
  //             const sizeObj = new PVHSizeModel(size.size, size.quantity, size.price);
  //             sizeArray.push(sizeObj);
  //           });
  //           const col = new PVHColorModel(color, sizeArray);
  //           ColArray.push(col);
  //         });
  //         const des = new PVHDestinationModel(dest, ColArray);
  //         desArray.push(des);
  //       });
  //       const poInfo = poMap.get(poNumber);


  //       const co = new PVHCoLinereqModel(poInfo.poNumber, poInfo.unitPrice, poInfo.currency, poInfo.deliveryDate, poInfo.exFactoryDate, null, desArray);
  //       coData.push(co);
  //     });

  //     if (coData.length > 0) {
  //       return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'No data found');
  //     }
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  // async getOrderdataForCOline(req: OrderDetailsReq): Promise<CommonResponseModel> {
  //   try {
  //     const poLineValues = req.poLine.split(',');
  //     const ordersData = await this.PvhOrdersRepo.find({ where: { poNumber: req.poNumber, poLine: In(poLineValues), buyerName: req.buyerName } });

  //     const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string, price: string }[]>>>();
  //     const poMap = new Map<string, PVHOrdersEntity>();

  //     for (const order of ordersData) {
  //       poMap.set(`${order.poNumber}`, order);

  //       const parts = order.deliveryAddress.split(',');
  //       // const dest = parts[2]?.trim() ? parts[2]?.trim() : parts[1]?.trim() ? parts[1]?.trim() :order.deliveryAddress
  //       const dest =  parts[2]?.trim() || parts[1]?.trim() || order.deliveryAddress;


  //       // const dest = order.deliveryAddress

  //       if (!destinationColSizesMap.has(`${order.poNumber}`)) {
  //         destinationColSizesMap.set(`${order.poNumber}`, new Map<string, Map<string, { size: string, quantity: string, price: string }[]>>());
  //       }

  //       if (!destinationColSizesMap.get(`${order.poNumber}`).has(dest)) {
  //         destinationColSizesMap.get(`${order.poNumber}`).set(dest, new Map<string, { size: string, quantity: string, price: string }[]>());
  //       }

  //       const check = await this.colorRepo.findOne({ where: { style: order.plmStyle, buySheetColorName: order.color } });
  //       const color = check ? check.movexColorName : order.color;

  //       if (!destinationColSizesMap.get(order.poNumber).get(dest).has(color)) {
  //         destinationColSizesMap.get(order.poNumber).get(dest).set(color, []);
  //       }

  //       const sizecheck = await this.sizeRepo.findOne({
  //         where: {
  //           size: order.size, dim: order.dimensions, sizeDescription: order.sizeDescription
  //         }
  //       });

  //       const sizecheckData = sizecheck ? sizecheck.movexSize : order.size

  //       if (sizecheck) {
  //         destinationColSizesMap.get(`${order.poNumber}`).get(dest).get(color).push({ size: sizecheckData, quantity: order.quantity, price: order.unitPrice });

  //       } 


  //     }

  //     const coData = [];

  //     destinationColSizesMap.forEach((destColorSize, poNumber) => {
  //       const desArray = [];

  //       destColorSize.forEach((colorSizes, dest) => {
  //         const ColArray = [];

  //         colorSizes.forEach((sizes, color) => {
  //           const sizeArray = sizes.map(size => new PVHSizeModel(size.size, size.quantity, size.price));
  //           const col = new PVHColorModel(color, sizeArray, sizeArray[0].price);
  //           ColArray.push(col);
  //         });

  //         const des = new PVHDestinationModel(dest, ColArray);
  //         desArray.push(des);
  //       });

  //       const poInfo = poMap.get(poNumber);
  //       const co = new PVHCoLinereqModel(poInfo.poNumber, poInfo.unitPrice, poInfo.currency, poInfo.deliveryDate, poInfo.exFactoryDate, null, desArray);
  //       coData.push(co);
  //     });

  //     if (coData.length > 0) {
  //       return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'No data found');
  //     }
  //   } catch (err) {
  //     // Handle error appropriately, maybe log it
  //     console.error(err);
  //     throw new Error('Error retrieving data');
  //   }
  // }

  async coLineCreationReq(req: any): Promise<CommonResponseModel> {
    // const records = await this.PvhOrdersRepo.find({ where: { poNumber: req.poNumber } });
    // console.log(records,"recordssssss")
    // const uniquePoLines = [...new Set(records.map((rec) => rec.poLine))];
    // console.log(uniquePoLines,"uniquePoLines")
    const entities: any[] = []
    for (const rec of req.coReqDetails) {
      const entity = new PvhCOLineEntity()
      entity.poLine = rec.poLine
      entity.buyerName = rec.buyerName
      entity.poNumber = rec.poNumber;
      entity.plmStyle = rec.plmStyle;
      entity.itemNo = rec.itemNo;
      entity.status = 'Open';
      entity.deliveryDate = rec.deliveryDate;
      entity.transMode = rec.transMode
      entity.portOfLoading = rec.portOfLoading;
      entity.shortDescription = rec.shortDescription;
      entity.division = rec.division;
      entity.gender = rec.gender;
      entity.deliveryAddress = rec.deliveryAddress
      entity.totalQuantity = rec.totalQuantity
      entity.orderValue = rec.orderValue
      entity.createdUser = 'admin';
      entities.push(entity)
    }
    const save = await this.pvhCoLineRepo.save(entities);
    if (save.length) {
      for (const saved of save) {
        // console.log(saved.poNumber)
        await this.updateCOLineStatus({ poNumber: saved.poNumber, itemNo: req.itemNo, status: 'Open', })
        const update = await this.PvhOrdersRepo.update(
          { poNumber: saved.poNumber, transMode: saved.transMode, deliveryDate: saved.deliveryDate },
          { status: StatusEnum.INPROGRESS, buyerName: saved.buyerName }
        );
      }
      return new CommonResponseModel(true, 1, 'CO-Line request created successfully')
    } else {
      return new CommonResponseModel(false, 1, 'CO-Line request failed')
    }
  }

  async getCoLineData(req?: PvhOrderFilter): Promise<CommonResponseModel> {
    const data = await this.pvhCoLineRepo.getCoLineData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getCoPoNumber(req?: any): Promise<CommonResponseModel> {
    const data = await this.pvhCoLineRepo.getCoPoNumber(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getItem(req?: any): Promise<CommonResponseModel> {
    try {
      const data = await this.pvhCoLineRepo.getItem(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async deleteCoLine(req: ItemNoDtos): Promise<CommonResponseModel> {
    try {
      const itemToDelete = await this.pvhCoLineRepo.findOne({ where: { id: Number(req.id) } });

      if (!itemToDelete) {
        return new CommonResponseModel(false, 0, "Item No not found", []);
      }

      if (itemToDelete.status === "Success") {
        itemToDelete.isActive = Boolean(0);
        await this.pvhCoLineRepo.save(itemToDelete);
        return new CommonResponseModel(true, 1, "Deleted Successfully");
      } else {
        const deleteResult = await this.pvhCoLineRepo.delete({ id: Number(req.id) });
        if (deleteResult && deleteResult.affected) {
          return new CommonResponseModel(true, 1, "Deleted Successfully");
        } else {
          return new CommonResponseModel(false, 0, "Something Went Wrong", []);
        }
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting or updating ItemNo status", error);
    }
  }

  // async deleteCoLine(req: ItemNoDtos): Promise<CommonResponseModel> {
  //   console.log(req, "reqq");
  //   try {
  //     const deletedItem = await this.pvhCoLineRepo.delete({ id: Number(req.id) });

  //     if (deletedItem && deletedItem.affected) {
  //       return new CommonResponseModel(true, 1, "ItemNo Deleted Successfully");
  //     } else {
  //       return new CommonResponseModel(false, 0, "Item No: Something went wrong", []);
  //     }
  //   } catch (error) {
  //     return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
  //   }
  // }

  async deleteCoLines(req: ItemNoDtos): Promise<CommonResponseModel> {
    try {
      const idsToDelete = Array.isArray(req.id) ? req.id.map(id => Number(id)) : [Number(req.id)];
      const itemsToDelete = await this.pvhCoLineRepo.find({ where: { id: In(idsToDelete) } });
      if (!itemsToDelete || itemsToDelete.length === 0) {
        return new CommonResponseModel(false, 0, "Items not found", []);
      }
      const deletePromises = itemsToDelete.map(async item => {
        if (item.status === "Success") {
          item.isActive = false;
          await this.pvhCoLineRepo.save(item);
        } else {
          const deleteResult = await this.pvhCoLineRepo.delete({ id: item.id });
          if (deleteResult && deleteResult.affected) {
            return new CommonResponseModel(true, 1, "Deleted Successfully");
          } else {
            return new CommonResponseModel(false, 0, "Something Went Wrong", []);
          }
        }
      });
      await Promise.all(deletePromises);
      return new CommonResponseModel(true, itemsToDelete.length, "Deleted Successfully");
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting or updating ItemNo status", error);
    }
  }

  async updateItemNo(req: ItemNoDtos): Promise<CommonResponseModel> {
    try {
      const update = await this.pvhCoLineRepo.update(
        { id: Number(req.id) },
        { itemNo: req.itemNo, deliveryDate: req.deliveryDate }
      );
      if (update) {
        return new CommonResponseModel(true, 1, "ItemNo Update Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Item No: Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while updating ItemNo", error);
    }
  }

  async updateStatusInOrder(req: any): Promise<CommonResponseModel> {
    const poLineValues = req.poLine.split(',');
    try {
      const update = await this.PvhOrdersRepo.update(
        { poNumber: req.poNumber, poLine: In(poLineValues) },
        { status: StatusEnum.OPEN }
      );
      if (update) {
        return new CommonResponseModel(true, 1, "Updated Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }

  // async getordercomparationData(req?: any): Promise<CommonResponseModel> {
  //   try {
  //     const Originaldata = await this.PvhOrdersRepo.getordercomparationData(req)
  //     const compareModel: PvhCompareModel[] = []

  //     for (const rec of Originaldata) {
  //       const childData = await this.PvhOrdersChildRepo.find({
  //         where: {
  //           poNumber: rec.po_number, poLine: rec.po_line, size: rec.size
  //         }, order: { id: 'DESC' }, take: 1, skip: 1
  //       })
  //       if (childData.length > 0) {
  //         const oldData = childData[0];
  //         // Check for changes in values
  //         if (
  //           oldData.unitPrice !== rec.unit_price ||
  //           oldData.deliveryDate !== rec.delivery_date ||
  //           oldData.quantity !== rec.quantity
  //         ) {
  //           // Only push if there are changes
  //           compareModel.push(new
  //             PvhCompareModel(
  //               rec.po_number,
  //               rec.po_line,
  //               rec.size,
  //               oldData.unitPrice,
  //               rec.unit_price,
  //               oldData.deliveryDate,
  //               rec.delivery_date,
  //               oldData.quantity,
  //               rec.quantity,
  //               oldData.transMode,
  //               rec.trans_mode,
  //               oldData.deliveryAddress,
  //               rec.delivery_address,

  //             ));
  //         }
  //       }
  //     }
  //     if (compareModel) {

  //       return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', compareModel);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'No data found');
  //     }
  //   } catch (err) {
  //     throw err
  //   }
  // }

  async getordercomparationData(req?: any): Promise<CommonResponseModel> {
    try {
      const Originaldata = await this.PvhOrdersRepo.getordercomparationData(req);
      if (Originaldata.length === 0) {
        return new CommonResponseModel(false, 0, 'No data found');
      }
      const poNumbers = new Set(Originaldata.map(rec => rec.po_number));
      const poLines = new Set(Originaldata.map(rec => rec.po_line));
      const sizes = new Set(Originaldata.map(rec => rec.size));
      const childDataList = await this.PvhOrdersChildRepo.find({
        where: {
          poNumber: In(Array.from(poNumbers)),
          poLine: In(Array.from(poLines)),
          size: In(Array.from(sizes))
        },
        order: { id: 'DESC' }
      });
      const childDataMap = new Map<string, PvhOrderschildEntity[]>();
      for (const childData of childDataList) {
        const key = `${childData.poNumber}-${childData.poLine}-${childData.size}`;
        const currentList = childDataMap.get(key) || [];
        currentList.push(childData);
        childDataMap.set(key, currentList);
      }
      const compareModel: PvhCompareModel[] = [];
      for (const rec of Originaldata) {
        const key = `${rec.po_number}-${rec.po_line}-${rec.size}`;
        const childRecords = childDataMap.get(key);
        if (childRecords && childRecords.length > 1) {
          const [mostRecent, previous] = childRecords;
          if (
            previous.unitPrice !== rec.unit_price ||
            previous.deliveryDate !== rec.delivery_date ||
            previous.quantity !== rec.quantity
          ) {
            compareModel.push(new PvhCompareModel(
              rec.po_number,
              rec.po_line,
              rec.size,
              previous.unitPrice,
              rec.unit_price,
              previous.deliveryDate,
              rec.delivery_date,
              previous.quantity,
              rec.quantity,
              previous.transMode,
              rec.trans_mode,
              previous.deliveryAddress,
              rec.delivery_address,
              new Date(previous.createdAt).toISOString().slice(0, 10),
              new Date(rec.created_at).toISOString().slice(0, 10)
            ));
          }
        }
      }
      return compareModel.length > 0
        ? new CommonResponseModel(true, 1, 'Data Retrieved Successfully', compareModel)
        : new CommonResponseModel(false, 0, 'No data found');
    } catch (err) {
      console.error("Error in getordercomparationData:", err);
      throw new Error('Failed to retrieve order comparison data due to internal error.');
    }
  }
  
  async getOrderdataForCOline(req: OrderDetailsReq): Promise<CommonResponseModel> {
    try {
      const poLineValues = req.poLine.split(',');
      const ordersData = await this.PvhOrdersRepo.find({ where: { poNumber: req.poNumber, poLine: In(poLineValues), buyerName: req.buyerName } });
      const getAddressData = await this.addressService.getAddressInfo()
      const buyerAddressMatchingData = getAddressData.data.map((j => {
        return {
          ...j
        }
      }))
      const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: string, price: string }[]>>>();
      const poMap = new Map<string, PVHOrdersEntity>();
      for (const order of ordersData) {
        let dest;
        poMap.set(`${order.poNumber}`, order);
        const orginalOrderDeliveryAddress = order.deliveryAddress.trim();
        const matchingData = buyerAddressMatchingData.find(j => j.deliveryAddress === orginalOrderDeliveryAddress);
        if (matchingData) {
          dest = orginalOrderDeliveryAddress;
        }
        // else {
        //   const parts = order.deliveryAddress.split(',');
        //   dest = parts[2]?.trim() || parts[1]?.trim() || order.deliveryAddress;
        // }
        if (!destinationColSizesMap.has(`${order.poNumber}`)) {
          destinationColSizesMap.set(`${order.poNumber}`, new Map<string, Map<string, { size: string, quantity: string, price: string }[]>>());
        }
        if (!destinationColSizesMap.get(`${order.poNumber}`).has(dest)) {
          destinationColSizesMap.get(`${order.poNumber}`).set(dest, new Map<string, { size: string, quantity: string, price: string }[]>());
        }

        const check = await this.colorRepo.find({ where: { item: req.itemNo, style: order.plmStyle, buySheetColorName: order.color } });
        // const color = check ? check.movexColorName : order.color;
        const color = check.length > 0 ? check.map(i => i.movexColorName).join(',') : order.color

        if (!destinationColSizesMap.get(order.poNumber).get(dest).has(color)) {
          destinationColSizesMap.get(order.poNumber).get(dest).set(color, []);
        }

        const sizecheck = await this.sizeRepo.find({
          where: {
            size: order.size, dim: order.dimensions, sizeDescription: order.sizeDescription, buyerName: order.buyerName
          }
        });

        // const sizecheckData = sizecheck ? sizecheck.movexSize : order.size
        const sizecheckData = sizecheck.length > 0
          ? sizecheck.map(item => item.movexSize).join(',')
          : order.size;
        const sizesMap = destinationColSizesMap.get(order.poNumber).get(dest).get(color);

        if (sizecheckData) {
          const existingSize = sizesMap.find((sizeObj) => sizeObj.size === sizecheckData);
          if (existingSize) {
            existingSize.quantity = (parseInt(existingSize.quantity.replace(/,/g, '')) + parseInt(order.quantity.replace(/,/g, ''))).toString();
          } else {
            sizesMap.push({ size: sizecheckData, quantity: order.quantity, price: order.unitPrice });
          }
        }
      }
      const coData = [];
      destinationColSizesMap.forEach((destColorSize, poNumber) => {
        const desArray = [];
        destColorSize.forEach((colorSizes, dest) => {
          const ColArray = [];

          colorSizes.forEach((sizes, color) => {
            const sizeArray = sizes.map(size => new PVHSizeModel(size.size, size.quantity, size.price));
            const col = new PVHColorModel(color, sizeArray, sizeArray[0].price);
            ColArray.push(col);
          });
          const matchingData = buyerAddressMatchingData.find(j => j.deliveryAddress === dest);
          const des = new PVHDestinationModel(
            dest,
            ColArray,
            matchingData?.buyerAddressCode,
            matchingData?.deliveryAddressCode,
          );
          desArray.push(des);
        });

        const poInfo = poMap.get(poNumber);
        const co = new PVHCoLinereqModel(poInfo.poNumber, poInfo.unitPrice, poInfo.currency, poInfo.deliveryDate, poInfo.exFactoryDate, poInfo.plmStyle, desArray);
        coData.push(co);
      });

      if (coData.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      console.error(err);
      throw new Error('Error retrieving data');
    }
  }

  @Cron('*/4 * * * *')
  async createCOline(req: any): Promise<CommonResponseModel> {
    const po = await this.pvhCoLineRepo.getDataforCOLineCreation();
    if (!po) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation requests')
    }
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('99901347');
      await driver.findElement(By.id('password')).sendKeys('99901347');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      const newPAge = await driver.executeScript(
        `javascript:openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      );
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)
      const coLine = new CoLineRequest();
      let buyerValue1;
      let buyerValue2;
      let agent;
      let buyerAddress;
      let deliveryAddress;
      let pkgTerms;
      let paymentTerms;
      let styleNo;

      if (po.buyer_name === 'TommyNorthAmerica') {
        const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line, buyerName: po.buyer_name, itemNo: po.item_no }, { status: 'Inprogress' });
        const response = await this.getOrderdataForCOline({ poNumber: po.po_number, poLine: po.po_line, itemNo: po.item_no })
        console.log(response.data[0], "response")
        const coData = response.data[0];
        coLine.buyerPo = coData.poNumber
        coLine.deliveryDate = po.delivery_date
        coLine.salesPrice = coData.salesPrice
        coLine.currency = coData.currency
        coLine.destinations = coData.destinations
        coLine.exFactoryDate = coData.exfactoryDate
        const request = coData.destinations[0]?.name;
        // const address = await this.addressService.getAddressInfoByCountry({ country: request, buyerName: po.buyer_name });
        // const addressData = address.data[0];
        // console.log(addressData, "addressData")
        console.log("----------------start----------------")
        if (!request) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        console.log("----------------end----------------")
        styleNo = coData.style
        // buyerAddress = addressData?.buyerAddressCode
        // deliveryAddress = addressData?.deliveryAddressCode
        buyerAddress = coData.destinations[0]?.buyerAddressCode
        deliveryAddress = coData.destinations[0]?.deliveryAddressCode
        if (buyerAddress === undefined || buyerAddress === null || buyerAddress === "" ||
          deliveryAddress === undefined || deliveryAddress === null || deliveryAddress === ""
        ) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        buyerValue1 = "PVH-PVH GROUP"
        buyerValue2 = "PVHT001-TOMMY HILFIGER EUROPE BV"
        agent = "NA-DIRECT CUSTOMER"
        pkgTerms = "BOX-BOXES"
        paymentTerms = "081-TT  90 Days"
      }
      else if (po.buyer_name === 'CKNorthAmerica') {
        const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line, buyerName: po.buyer_name, itemNo: po.item_no }, { status: 'Inprogress' });
        const response = await this.getOrderdataForCOline({
          poNumber: po.po_number, poLine: po.po_line, itemNo: po.item_no
        })
        const coData = response.data[0];
        coLine.buyerPo = coData.poNumber
        coLine.deliveryDate = po.delivery_date
        coLine.salesPrice = coData.salesPrice
        coLine.currency = coData.currency
        coLine.destinations = coData.destinations
        coLine.exFactoryDate = coData.exfactoryDate
        const request = coData.destinations[0]?.name;
        console.log(request, "request")
        // const address = await this.addressService.getAddressInfoByCountry({ country: request, buyerName: po.buyer_name });
        // const addressData = address.data[0];
        console.log("----------------start----------------")
        if (!request) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        console.log("----------------end----------------")
        styleNo = coData.style
        // buyerAddress = addressData?.buyerAddressCode
        // deliveryAddress = addressData?.deliveryAddressCode
        buyerAddress = coData.destinations[0]?.buyerAddressCode
        deliveryAddress = coData.destinations[0]?.deliveryAddressCode
        if (buyerAddress === undefined || buyerAddress === null || buyerAddress === "" ||
          deliveryAddress === undefined || deliveryAddress === null || deliveryAddress === ""
        ) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        buyerValue1 = "CAL-CALVIN KLEIN"
        buyerValue2 = "CKJ00001-WARNACO"
        agent = "-NA"
        pkgTerms = "BOX-BOXES"
        paymentTerms = "058-TT 45 days"

      }
      else if (po.buyer_name === 'TommyEurope') {
        const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line, buyerName: po.buyer_name, itemNo: po.item_no }, { status: 'Inprogress' });
        const response = await this.getOrderdataForCOline({ poNumber: po.po_number, poLine: po.po_line, itemNo: po.item_no })
        console.log(response.data[0], "response")
        const coData = response.data[0];
        coLine.buyerPo = coData.poNumber
        coLine.deliveryDate = po.delivery_date
        coLine.salesPrice = coData.salesPrice
        coLine.currency = coData.currency
        coLine.destinations = coData.destinations
        coLine.exFactoryDate = coData.exfactoryDate
        const request = coData.destinations[0]?.name;
        console.log(request, "request")
        // const address = await this.addressService.getAddressInfoByCountry({ country: request, buyerName: po.buyer_name });
        // console.log(address,"aaaaaaaaa")
        // const addressData = address.data[0];
        // console.log(addressData,"addressDataaddressData")
        console.log("----------------start----------------")
        if (!request) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        console.log("----------------end----------------")
        // console.log(addressData, "address")
        styleNo = coData.style
        // buyerAddress = addressData?.buyerAddressCode
        // deliveryAddress = addressData?.deliveryAddressCode
        buyerAddress = coData.destinations[0]?.buyerAddressCode
        deliveryAddress = coData.destinations[0]?.deliveryAddressCode
        if (buyerAddress === undefined || buyerAddress === null || buyerAddress === "" ||
          deliveryAddress === undefined || deliveryAddress === null || deliveryAddress === ""
        ) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        buyerValue1 = "PVH-PVH GROUP"
        buyerValue2 = "PVHT001-TOMMY HILFIGER EUROPE BV"
        agent = "-NA"
        pkgTerms = "BOX-BOXES"
        paymentTerms = "031-Trde Card45 Day"
      }
      else if (po.buyer_name === 'CKEurope') {
        const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line, buyerName: po.buyer_name, itemNo: po.item_no }, { status: 'Inprogress' });
        const response = await this.getOrderdataForCOline({ poNumber: po.po_number, poLine: po.po_line, itemNo: po.item_no })
        console.log(response.data[0], "response")
        const coData = response.data[0];
        coLine.buyerPo = coData.poNumber
        coLine.deliveryDate = po.delivery_date
        coLine.salesPrice = coData.salesPrice
        coLine.currency = coData.currency
        coLine.destinations = coData.destinations
        coLine.exFactoryDate = coData.exfactoryDate
        const request = coData.destinations[0]?.name;
        console.log(request, "request")
        // const address = await this.addressService.getAddressInfoByCountry({ country: request, buyerName: po.buyer_name });
        // const addressData = address.data[0];
        // console.log(addressData, "Address data")
        console.log("----------------start----------------")
        if (!request) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        console.log("----------------end----------------")
        styleNo = coData.style
        // buyerAddress = addressData?.buyerAddressCode
        // deliveryAddress = addressData?.deliveryAddressCode
        buyerAddress = coData.destinations[0]?.buyerAddressCode
        deliveryAddress = coData.destinations[0]?.deliveryAddressCode
        if (buyerAddress === undefined || buyerAddress === null || buyerAddress === "" ||
          deliveryAddress === undefined || deliveryAddress === null || deliveryAddress === ""
        ) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { status: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          if (update.affected) {
            await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
            return new CommonResponseModel(false, 0, "Address not matching")
          }
        }
        buyerValue1 = "CKE-Calvin Klein Europe"
        buyerValue2 = "CKE00001-CALVIN KLEIN EUROPE"
        agent = "-NA"
        pkgTerms = "BOX-BOXES"
        paymentTerms = "003-Credit 30 Days"
      }
      await driver.sleep(3000)
      const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]')));
      const allApps = await apps.findElements(By.tagName('span'));
      for (const app of allApps) {
        if ((await app.getAttribute('innerText')).includes('Style Orders')) {
          await driver.executeScript('arguments[0].click();', app);
          break;
        }
      }
      await driver.sleep(5000)
      await driver.wait(until.elementLocated(By.id('styleid2H')))
      await driver.findElement(By.id('styleid2H')).sendKeys(po.item_no);
      await driver.sleep(5000)
      await driver.wait(until.elementLocated(By.id('bgpset1')));
      const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
      const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
      await dropdown1.selectByValue(buyerValue1)
      await driver.sleep(5000)
      await driver.wait(until.elementLocated(By.id('byr')));
      const dropdownElement2 = await driver.findElement(By.id('byr'));
      const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
      await dropdown2.selectByValue(buyerValue2)
      await driver.sleep(1000)
      await driver.wait(until.elementLocated(By.id('CreateOrderID')))
      await driver.sleep(3000)
      await driver.findElement(By.id('CreateOrderID')).click();
      // try {
      //   const errorElemetOne = await driver.wait(until.elementLocated(By.xpath('//*[@id="form1bgb"]/table/tbody/tr[2]/td/table/tbody/tr[1]/td/ul/li/span')), 5000);
      //   await driver.sleep(1000)
      //   const elementErrorText = await errorElemetOne.getText();
      //   await driver.sleep(1000)
      //   console.log(elementErrorText, "elementErrorText")
      //   if (elementErrorText.includes("All Item SKU Variants are in status 90.")) {
      //     const update = await this.pvhCoLineRepo.update(
      //       { poNumber: po.po_number, poLine: po.po_line },
      //       { status: "Failed", errorMsg: `All Item SKU Variants are in status 90.`, isActive: false }
      //     );
      //     await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
      //     return new CommonResponseModel(false, 0, "All Item SKU Variants are in status 90.")
      //   }
      //   else if (elementErrorText.includes("order is not created as foreign currency is not permissible in case of India")) {
      //     const update = await this.pvhCoLineRepo.update(
      //       { poNumber: po.po_number, poLine: po.po_line },
      //       { status: "Failed", errorMsg: `order is not created as foreign currency is not permissible in case of India`, isActive: false }
      //     );
      //     await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
      //     return new CommonResponseModel(false, 0, "order is not created as foreign currency is not permissible in case of India")
      //   }
      // } catch (err) {
      //   console.log("Starting Catch Error", err);
      // }
      console.log("Proceeding to the next steps")
      await driver.wait(until.elementLocated(By.id('bpo')))
      await driver.findElement(By.id('bpo')).clear();
      await driver.findElement(By.id('bpo')).sendKeys(coLine.buyerPo);
      await driver.wait(until.elementLocated(By.id('bus')))
      await driver.findElement(By.id('bus')).clear();
      await driver.findElement(By.id('bus')).sendKeys(styleNo);
      await driver.wait(until.elementLocated(By.id('agnt')));
      const agentDropDown = await driver.findElement(By.id('agnt'));
      await driver.executeScript(`arguments[0].value = '${agent}';`, agentDropDown)
      await driver.wait(until.elementLocated(By.name('dojo.EXFACTORYDATE')));
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).clear();
      await driver.findElement(By.name('dojo.EXFACTORYDATE')).sendKeys(coLine.exFactoryDate);
      await driver.wait(until.elementLocated(By.name('dojo.delydt')));
      await driver.findElement(By.name('dojo.delydt')).clear();
      await driver.findElement(By.name('dojo.delydt')).sendKeys(coLine.deliveryDate);
      await driver.wait(until.elementLocated(By.name('byd')));
      const dropdown = await driver.findElement(By.name('byd'));
      const options = await dropdown.findElements(By.tagName('option'));
      const optionValues = [];
      for (const option of options) {
        const value = await option.getAttribute('value');
        optionValues.push(value);
      }
      const number = optionValues.find(value => {
        return Number(value.split('-')[0].trim()) == Number(buyerAddress)
      });
      await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
      await driver.wait(until.elementLocated(By.xpath('//*[@id="cur"]')));
      const curDropdown = await driver.findElement(By.xpath('//*[@id="cur"]'));
      const cur = coLine.currency;
      await driver.executeScript(`arguments[0].value = '${cur}';`, curDropdown);

      await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
      await driver.findElement(By.xpath('//*[@id="price"]')).clear();
      await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(coLine.salesPrice);

      await driver.wait(until.elementLocated(By.id('packtrm')));
      const pkgTermsDropDown = await driver.findElement(By.id('packtrm'));
      await driver.executeScript(`arguments[0].value = '${pkgTerms}';`, pkgTermsDropDown)
      await driver.wait(until.elementLocated(By.id('ptr')));
      const ptrDropDown = await driver.findElement(By.id('ptr'));
      await driver.executeScript(`arguments[0].value = '${paymentTerms}';`, ptrDropDown)
      await driver.sleep(10000)
      for (let dest of coLine.destinations) {
        const colorsContainer = await driver.wait(until.elementLocated(By.xpath('//*[@id="COContainer"]')));
        const colorsTabs = await colorsContainer.findElements(By.tagName('span'));
        for (const tab of colorsTabs) {

          if ((await tab.getAttribute('innerText')) == dest.name) {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    // await inputField.clear();
                    // await inputField.sendKeys(size.price);
                  }
                }
                const inputId = `${size.name}:${color.name.toString().toUpperCase().trim()}:${dest.name}`.replace(/\*/g, '');
                const input = await driver.wait(until.elementLocated(By.id(inputId)))
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
            await driver.executeScript('arguments[0].click();', tab);
            const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
            const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;
            // parent div ids
            /**
             * to read sizes : nameDiv1359QZD001
             * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
             * to read input fields: percentageDiv1359QZD001
             * 
             */
            const allSizes = [];
            console.log('---------------------------------------------------------------');
            await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
            // -----------------------   SIZES Reading from UI logic start ---------------
            // read all the sizes from the DOM
            let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
            const totalElements = labelElements?.length;
            // console.log('Total elements : ' + totalElements);
            labelElements.forEach(async r => {
              const label = (await r.getText()).trim().toUpperCase().toString();
              allSizes.push(label);
            });
            // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
            let i = 1;
            while (i <= 10) {
              // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
              const toJump = Math.min(i * 8, totalElements);
              const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
              // scroll the pointer to right side
              driver.executeScript("arguments[0].scrollIntoView()", rightEle);
              driver.sleep(1000);
              // read all the visible sizes from the DOM
              let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
              // console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
              currentUserVisbileElements.forEach(async (r, index) => {
                if (allSizes[index] == '') {
                  // console.log(index, "index");
                  const label = (await r.getText()).trim().toUpperCase().toString();
                  allSizes[index] = label;
                }
              });
              console.log(allSizes);
              i++;
            }
            // construct a reverse mapping of size => column location for easy scrolling during qty input
            const sizeToDisplayRowColumnIndex = [];
            allSizes.forEach((size, i) => {
              sizeToDisplayRowColumnIndex[size] = i;
            })
            // -----------------------   SIZES Reading from UI logic END ---------------
            // ---------------------- COLOR GETTING LOGIC START -------------------------
            const colorsInTable = [];
            const colorsToDisplayRowColumnIndex = [];
            // get the total colors for the current PO from the UI
            const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
            console.log('total colors : ' + totalColorElements.length);
            let cc = 0;
            for (const r of totalColorElements) {
              // console.log("plesessssssssssssssssss")
              // scroll to the specific location in the screen to read the color 
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
              // execute the scroll command
              await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              await driver.sleep(500);
              // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
              const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
              // console.log(sepcificRowColorEle, "sepcificRowColorEle");
              const displayingColor = (await sepcificRowColorEle[0]?.getText());
              // push the color to an array
              colorsInTable.push(displayingColor);
              cc++;
            }

            // now reverse map the color -> exact row index in the DOM
            colorsInTable.forEach((color, index) => {
              colorsToDisplayRowColumnIndex[color] = index;
            });
            // ---------------------- COLOR GETTING LOGIC END -------------------------

            //  console.log("ppppppppppppppp")
            for (let [colorIndex, color] of dest.colors.entries()) {
              let matchedColor = null;
              const multiColors = color.name.split(',').map(name => name.trim());
              // console.log(color.name, "color.namecolor.name")
              for (const orginalColorName of multiColors) {
                if (colorsInTable.includes(orginalColorName)) {
                  matchedColor = orginalColorName;
                }
              }
              if (!matchedColor) {
                const update = await this.pvhCoLineRepo.update(
                  { poNumber: po.po_number, poLine: po.po_line },
                  { status: 'Failed', errorMsg: `No matching color found`, isActive: false }
                );
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
                return new CommonResponseModel(false, 0, 'No Matching Color Found');
              }
              const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[matchedColor] + 1;
              if (colorsToDisplayRowColumnIndex[matchedColor] == undefined || colorsToDisplayRowColumnIndex[matchedColor] == null) {
                // break;
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                // driver.quit()
                return new CommonResponseModel(false, 0, 'No Matching Color Found')
              }
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
              driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              driver.sleep(500);
              try {
                const saleInput = `${matchedColor.toUpperCase().toString().trim()}ASSORTED`;
                console.log(saleInput, "saleInput")
                const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
              } catch (error) {
                console.error("Error finding sale price input:", error);
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                // driver.quit()
                return new CommonResponseModel(false, 0, 'No Matching Color Found')
              }
              for (let [sizeIndex, size] of color.sizes.entries()) {
                let matchedSize = null;
                const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                if (!exactSizeColumnScrollLocation) {
                  const update = await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'NO Matching Size found')
                }
                // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                // Now for this specific size, scroll to the exact location in the interface where the size is visible
                const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(300);
                // if (colorIndex >= 0) {
                // Find all the labels in the second row.
                await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                const fileteredElements: any[] = [];
                for (const labelElement of labelElements) {
                  const ele = (await labelElement.getText())?.trim();
                  ele.length > 0 ? fileteredElements.push(labelElement) : '';
                }
                let tabIndex = 1;
                const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                const options = await dropdown.findElements(By.tagName('option'));
                const optionValues = [];
                for (const option of options) {
                  const value = await option.getAttribute('value');
                  optionValues.push(value);
                }
                const number = optionValues.find(value => {
                  return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                });
                console.log(number, "nummmm")
                // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                // Find all the input fields in the first row.
                const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                // Create a map of size labels to input fields.
                const sizeToInputMap = {};
                for (let i = 0; i < fileteredElements.length; i++) {
                  const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                  // console.log(label, "labellabellabel")
                  if (label.length)
                    sizeToInputMap[label] = inputElements[i];
                }
                // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                // console.log(size.name, "ssssssssssss")
                // const labelNames = Object.keys(sizeToInputMap);
                // const sizeNameVariants = size.name.trim().toUpperCase().split(',').map(val => val.trim());  // Split comma-separated values into an array             
                // console.log(labelNames, "labelNames")
                // console.log(sizeNameVariants, "ssssssssssss")

                // if (inputField) {
                //   // Clear the existing value (if any) and fill it with the new price.
                //   await inputField.clear();
                //   await inputField.sendKeys(size.price);
                // } else {
                //   const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //   await this.updateCOLineStatus({ poNumber: po.po_number, lineItemNo: po.po_line, status: StatusEnum.FAILED })
                //   return new CommonResponseModel(false, 0, 'NO Matching Size found')
                // }
                const labelNames = Object.keys(sizeToInputMap);
                const sizeNameVariants = size.name.trim().toUpperCase().split(',').map((val) => val.trim());

                for (const sizeVariant of sizeNameVariants) {
                  if (labelNames.includes(sizeVariant)) {
                    matchedSize = sizeVariant;
                  }
                }
                if (matchedSize) {
                  // console.log(matchedSize, "iopiopiop")
                  const inputField = sizeToInputMap[matchedSize.trim().toUpperCase().toString()];
                  if (inputField) {
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    await this.pvhCoLineRepo.update(
                      { poNumber: po.po_number, poLine: po.po_line },
                      { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                    );
                    await this.updateCOLineStatus({
                      poNumber: po.po_number,
                      lineItemNo: po.po_line,
                      status: StatusEnum.FAILED,
                    });
                    return new CommonResponseModel(false, 0, 'No Matching Size Found');
                  }
                } else {
                  await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'No Matching Size Found');
                }
                // }
                const inputId = `${matchedSize}:${matchedColor.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                console.log(inputId, "ppppp")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'USA') {
            // console.log(dest.colors, "color")
            // console.log(dest.colors[0].sizes[0], "sizes")
            await driver.executeScript('arguments[0].click();', tab);
            const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
            const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;
            // parent div ids
            /**
             * to read sizes : nameDiv1359QZD001
             * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
             * to read input fields: percentageDiv1359QZD001
             * 
             */
            const allSizes = [];
            console.log('---------------------------------------------------------------');
            await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
            // -----------------------   SIZES Reading from UI logic start ---------------
            // read all the sizes from the DOM
            let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
            const totalElements = labelElements?.length;
            // console.log('Total elements : ' + totalElements);
            labelElements.forEach(async r => {
              const label = (await r.getText()).trim().toUpperCase().toString();
              allSizes.push(label);
            });
            // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
            let i = 1;
            while (i <= 10) {
              // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
              const toJump = Math.min(i * 8, totalElements);
              const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
              // scroll the pointer to right side
              driver.executeScript("arguments[0].scrollIntoView()", rightEle);
              driver.sleep(1000);
              // read all the visible sizes from the DOM
              let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
              // console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
              currentUserVisbileElements.forEach(async (r, index) => {
                if (allSizes[index] == '') {
                  // console.log(index, "index");
                  const label = (await r.getText()).trim().toUpperCase().toString();
                  allSizes[index] = label;
                }
              });
              console.log(allSizes);
              i++;
            }
            // construct a reverse mapping of size => column location for easy scrolling during qty input
            const sizeToDisplayRowColumnIndex = [];
            allSizes.forEach((size, i) => {
              sizeToDisplayRowColumnIndex[size] = i;
            })
            // -----------------------   SIZES Reading from UI logic END ---------------


            // ---------------------- COLOR GETTING LOGIC START -------------------------
            const colorsInTable = [];
            const colorsToDisplayRowColumnIndex = [];
            // get the total colors for the current PO from the UI
            const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
            console.log('total colors : ' + totalColorElements.length);
            let cc = 0;
            for (const r of totalColorElements) {
              // console.log("plesessssssssssssssssss")
              // scroll to the specific location in the screen to read the color 
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
              // execute the scroll command
              await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              await driver.sleep(500);
              // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
              const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
              const displayingColor = (await sepcificRowColorEle[0]?.getText());
              colorsInTable.push(displayingColor);
              cc++;
            }

            // now reverse map the color -> exact row index in the DOM
            colorsInTable.forEach((color, index) => {
              colorsToDisplayRowColumnIndex[color] = index;
            });
            // ---------------------- COLOR GETTING LOGIC END -------------------------
            // console.log(colorsInTable, "colorsInTable")
            for (let [colorIndex, color] of dest.colors.entries()) {
              let matchedColor = null;
              const multiColors = color.name.split(',').map(name => name.trim());
              // console.log(color.name, "color.namecolor.name")
              for (const orginalColorName of multiColors) {
                if (colorsInTable.includes(orginalColorName)) {
                  matchedColor = orginalColorName;
                }
              }
              if (!matchedColor) {
                // console.log(matchedColor, "matchedColor")
                const update = await this.pvhCoLineRepo.update(
                  { poNumber: po.po_number, poLine: po.po_line },
                  { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false }
                );
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
                return new CommonResponseModel(false, 0, 'No Matching Color Found');
              }
              const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[matchedColor] + 1;
              if (colorsToDisplayRowColumnIndex[matchedColor] == undefined || colorsToDisplayRowColumnIndex[matchedColor] == null) {
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                return new CommonResponseModel(false, 0, 'No Matching Color Found')
              }
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
              driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              driver.sleep(500);
              try {
                const saleInput = `${matchedColor.toUpperCase().toString().trim()}USA`;
                console.log(saleInput, "saleInput")
                const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
              } catch (error) {
                console.error("Error finding sale price input:", error);
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found ${matchedColor}`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                // driver.quit()
                return new CommonResponseModel(false, 0, 'Matching Color not found')
              }
              for (let [sizeIndex, size] of color.sizes.entries()) {
                let matchedSize = null;
                const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                if (!exactSizeColumnScrollLocation) {
                  const update = await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'NO Matching Size found')
                }
                // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                // Now for this specific size, scroll to the exact location in the interface where the size is visible
                const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(300);
                // if (colorIndex >= 0) {
                // Find all the labels in the second row.
                await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                const fileteredElements: any[] = [];
                for (const labelElement of labelElements) {
                  const ele = (await labelElement.getText())?.trim();
                  ele.length > 0 ? fileteredElements.push(labelElement) : '';
                }
                let tabIndex = 1; // Default to 1 if no match
                // if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
                //   tabIndex = 2
                // }
                const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                const options = await dropdown.findElements(By.tagName('option'));
                const optionValues = [];
                for (const option of options) {
                  const value = await option.getAttribute('value');
                  optionValues.push(value);
                }
                const number = optionValues.find(value => {
                  return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                });
                console.log(number, "nummmm")
                // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                // Find all the input fields in the first row.
                const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                // Create a map of size labels to input fields.
                const sizeToInputMap = {};
                for (let i = 0; i < fileteredElements.length; i++) {
                  const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString();
                  if (label.length)
                    sizeToInputMap[label] = inputElements[i];
                }
                const labelNames = Object.keys(sizeToInputMap);
                const sizeNameVariants = size.name.trim().toUpperCase().split(',').map((val) => val.trim());
                for (const sizeVariant of sizeNameVariants) {
                  if (labelNames.includes(sizeVariant)) {
                    matchedSize = sizeVariant;
                  }
                }
                if (matchedSize) {
                  const inputField = sizeToInputMap[matchedSize.trim().toUpperCase().toString()];
                  if (inputField) {
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    await this.pvhCoLineRepo.update(
                      { poNumber: po.po_number, poLine: po.po_line },
                      { status: 'Failed', errorMsg: 'Matching Size Input Field Not Found', isActive: false }
                    );
                    await this.updateCOLineStatus({
                      poNumber: po.po_number,
                      lineItemNo: po.po_line,
                      status: StatusEnum.FAILED,
                    });
                    return new CommonResponseModel(false, 0, 'Matching Size Input Field Not Found');
                  }
                } else {
                  await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'No Matching Size Found');
                }
                // }
                const inputId = `${matchedSize}:${matchedColor.toUpperCase().toString().trim()}:USA`.replace(/\*/g, '');
                console.log(inputId, "ppppp")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'EUR') {
            await driver.executeScript('arguments[0].click();', tab);

            const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
            const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;

            const allSizes = [];
            await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
            // -----------------------   SIZES Reading from UI logic start ---------------
            let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
            const totalElements = labelElements?.length;
            // labelElements.forEach(async r => {
            //   const label = (await r.getText()).trim().toUpperCase().toString();
            //   allSizes.push(label);
            // });
            for (let r of labelElements) {
              const label = (await r.getText()).trim().toUpperCase().toString();
              allSizes.push(label);
            }


            let i = 1;
            while (i <= 10) {
              const toJump = Math.min(i * 8, totalElements);
              const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
              driver.executeScript("arguments[0].scrollIntoView()", rightEle);
              driver.sleep(1000);

              let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              currentUserVisbileElements.forEach(async (r, index) => {
                if (allSizes[index] == '') {
                  const label = (await r.getText()).trim().toUpperCase().toString();
                  allSizes[index] = label;
                }
              });
              i++;
            }
            console.log(allSizes, '222222222')
            const sizeToDisplayRowColumnIndex = [];
            allSizes.forEach((size, i) => {
              sizeToDisplayRowColumnIndex[size] = i;
            })
            // -----------------------   SIZES Reading from UI logic END ---------------

            // ---------------------- COLOR GETTING LOGIC START -------------------------
            const colorsInTable = [];
            const colorsToDisplayRowColumnIndex = [];
            const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
            console.log('total colors : ' + totalColorElements.length);
            let cc = 0;
            for (const r of totalColorElements) {
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
              await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              await driver.sleep(500);
              const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
              const displayingColor = (await sepcificRowColorEle[0]?.getText());
              colorsInTable.push(displayingColor);
              cc++;
            }

            colorsInTable.forEach((color, index) => {
              colorsToDisplayRowColumnIndex[color] = index;
            });
            // ---------------------- COLOR GETTING LOGIC END -------------------------

            for (let [colorIndex, color] of dest.colors.entries()) {
              let matchedColor = null;
              const multiColors = color.name.split(',').map(name => name.trim());
              // console.log(color.name, "color.namecolor.name")
              for (const orginalColorName of multiColors) {
                if (colorsInTable.includes(orginalColorName)) {
                  matchedColor = orginalColorName;
                }
              }
              if (!matchedColor) {
                const update = await this.pvhCoLineRepo.update(
                  { poNumber: po.po_number, poLine: po.po_line },
                  { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false }
                );
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
                return new CommonResponseModel(false, 0, 'No Matching Color Found');
              }
              const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[matchedColor] + 1;
              if (colorsToDisplayRowColumnIndex[matchedColor] == undefined || colorsToDisplayRowColumnIndex[matchedColor] == null) {
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                return new CommonResponseModel(false, 0, 'No Matching Color Found')
              }
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
              driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              driver.sleep(500);

              let tabIndex = 1;
              const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
              await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
              const dropdown = await driver.findElement(By.id(`bydline/${string}`));
              const options = await dropdown.findElements(By.tagName('option'));
              const optionValues = [];
              for (const option of options) {
                const value = await option.getAttribute('value');
                optionValues.push(value);
              }
              const number = optionValues.find(value => {
                return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
              });
              console.log(number, "nummmm")

              await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
              const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
              try {
                const saleInput = `${matchedColor.toUpperCase().toString().trim()}EUR`;
                console.log(saleInput, "saleInput")
                const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
              } catch (error) {
                console.error("Error finding sale price input:", error);
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found ${matchedColor}`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                // driver.quit()
                return new CommonResponseModel(false, 0, 'Matching Color not found')
              }
              for (let [sizeIndex, size] of color.sizes.entries()) {
                let matchedSize = null;
                const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                if (!exactSizeColumnScrollLocation) {
                  const update = await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'NO Matching Size found')
                }
                // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);
                const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(600);
                // if (colorIndex >= 0) {
                await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                const fileteredElements: any[] = [];
                for (const labelElement of labelElements) {
                  const ele = (await labelElement.getText())?.trim();
                  ele.length > 0 ? fileteredElements.push(labelElement) : '';
                }

                // Find all the input fields in the first row.
                const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                // Create a map of size labels to input fields.
                const sizeToInputMap = {};
                for (let i = 0; i < fileteredElements.length; i++) {
                  const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString();
                  if (label.length)
                    sizeToInputMap[label] = inputElements[i];
                }
                const labelNames = Object.keys(sizeToInputMap);
                const sizeNameVariants = size.name.trim().toUpperCase().split(',').map((val) => val.trim())
                for (const sizeVariant of sizeNameVariants) {
                  if (labelNames.includes(sizeVariant)) {
                    matchedSize = sizeVariant;
                  }
                }
                if (matchedSize) {
                  const inputField = sizeToInputMap[matchedSize.trim().toUpperCase().toString()];
                  if (inputField) {
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    await this.pvhCoLineRepo.update(
                      { poNumber: po.po_number, poLine: po.po_line },
                      { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                    );
                    await this.updateCOLineStatus({
                      poNumber: po.po_number,
                      lineItemNo: po.po_line,
                      status: StatusEnum.FAILED,
                    });
                    return new CommonResponseModel(false, 0, 'No Matching Size Found');
                  }
                } else {
                  await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'No Matching Size Found');
                }
                // }
                const inputId = `${matchedSize}:${matchedColor.toUpperCase().toString().trim()}:EUR`.replace(/\*/g, '');
                console.log(inputId, "ppppp")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'EUROPE') {
            await driver.executeScript('arguments[0].click();', tab);

            const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
            const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;

            const allSizes = [];
            await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
            // -----------------------   SIZES Reading from UI logic start ---------------
            let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
            const totalElements = labelElements?.length;
            // labelElements.forEach(async r => {
            //   const label = (await r.getText()).trim().toUpperCase().toString();
            //   allSizes.push(label);
            // });
            for (let r of labelElements) {
              const label = (await r.getText()).trim().toUpperCase().toString();
              allSizes.push(label);
            }


            let i = 1;
            while (i <= 10) {
              const toJump = Math.min(i * 8, totalElements);
              const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
              driver.executeScript("arguments[0].scrollIntoView()", rightEle);
              driver.sleep(1000);

              let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              currentUserVisbileElements.forEach(async (r, index) => {
                if (allSizes[index] == '') {
                  const label = (await r.getText()).trim().toUpperCase().toString();
                  allSizes[index] = label;
                }
              });
              i++;
            }
            console.log(allSizes, '222222222')
            const sizeToDisplayRowColumnIndex = [];
            allSizes.forEach((size, i) => {
              sizeToDisplayRowColumnIndex[size] = i;
            })
            // -----------------------   SIZES Reading from UI logic END ---------------

            // ---------------------- COLOR GETTING LOGIC START -------------------------
            const colorsInTable = [];
            const colorsToDisplayRowColumnIndex = [];
            const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
            console.log('total colors : ' + totalColorElements.length);
            let cc = 0;
            for (const r of totalColorElements) {
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
              await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              await driver.sleep(500);
              const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
              const displayingColor = (await sepcificRowColorEle[0]?.getText());
              colorsInTable.push(displayingColor);
              cc++;
            }

            colorsInTable.forEach((color, index) => {
              colorsToDisplayRowColumnIndex[color] = index;
            });
            // ---------------------- COLOR GETTING LOGIC END -------------------------

            for (let [colorIndex, color] of dest.colors.entries()) {
              let matchedColor = null;
              const multiColors = color.name.split(',').map(name => name.trim());
              // console.log(color.name, "color.namecolor.name")
              for (const orginalColorName of multiColors) {
                if (colorsInTable.includes(orginalColorName)) {
                  matchedColor = orginalColorName;
                }
              }
              if (!matchedColor) {
                const update = await this.pvhCoLineRepo.update(
                  { poNumber: po.po_number, poLine: po.po_line },
                  { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false }
                );
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
                return new CommonResponseModel(false, 0, 'No Matching Color Found');
              }
              const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[matchedColor] + 1;
              if (colorsToDisplayRowColumnIndex[matchedColor] == undefined || colorsToDisplayRowColumnIndex[matchedColor] == null) {
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                return new CommonResponseModel(false, 0, 'No Matching Color Found')
              }
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
              driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              driver.sleep(500);

              let tabIndex = 1;
              const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
              await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
              const dropdown = await driver.findElement(By.id(`bydline/${string}`));
              const options = await dropdown.findElements(By.tagName('option'));
              const optionValues = [];
              for (const option of options) {
                const value = await option.getAttribute('value');
                optionValues.push(value);
              }
              const number = optionValues.find(value => {
                return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
              });
              console.log(number, "nummmm")

              await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
              const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
              try {
                const saleInput = `${matchedColor.toUpperCase().toString().trim()}EUROPE`;
                console.log(saleInput, "saleInput")
                const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
              } catch (error) {
                console.error("Error finding sale price input:", error);
                const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found ${matchedColor}`, isActive: false });
                await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
                // driver.quit()
                return new CommonResponseModel(false, 0, 'Matching Color not found')
              }
              for (let [sizeIndex, size] of color.sizes.entries()) {
                let matchedSize = null;
                const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                if (!exactSizeColumnScrollLocation) {
                  const update = await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'NO Matching Size found')
                }
                // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);
                const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(600);
                // if (colorIndex >= 0) {
                await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                const fileteredElements: any[] = [];
                for (const labelElement of labelElements) {
                  const ele = (await labelElement.getText())?.trim();
                  ele.length > 0 ? fileteredElements.push(labelElement) : '';
                }

                // Find all the input fields in the first row.
                const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                // Create a map of size labels to input fields.
                const sizeToInputMap = {};
                for (let i = 0; i < fileteredElements.length; i++) {
                  const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString();
                  if (label.length)
                    sizeToInputMap[label] = inputElements[i];
                }
                const labelNames = Object.keys(sizeToInputMap);
                const sizeNameVariants = size.name.trim().toUpperCase().split(',').map((val) => val.trim())
                for (const sizeVariant of sizeNameVariants) {
                  if (labelNames.includes(sizeVariant)) {
                    matchedSize = sizeVariant;
                  }
                }
                if (matchedSize) {
                  const inputField = sizeToInputMap[matchedSize.trim().toUpperCase().toString()];
                  if (inputField) {
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  } else {
                    await this.pvhCoLineRepo.update(
                      { poNumber: po.po_number, poLine: po.po_line },
                      { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                    );
                    await this.updateCOLineStatus({
                      poNumber: po.po_number,
                      lineItemNo: po.po_line,
                      status: StatusEnum.FAILED,
                    });
                    return new CommonResponseModel(false, 0, 'No Matching Size Found');
                  }
                } else {
                  await this.pvhCoLineRepo.update(
                    { poNumber: po.po_number, poLine: po.po_line },
                    { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
                  );
                  await this.updateCOLineStatus({
                    poNumber: po.po_number,
                    lineItemNo: po.po_line,
                    status: StatusEnum.FAILED,
                  });
                  return new CommonResponseModel(false, 0, 'No Matching Size Found');
                }
                // }
                const inputId = `${matchedSize}:${matchedColor.toUpperCase().toString().trim()}:EUROPE`.replace(/\*/g, '');
                console.log(inputId, "ppppp")
                const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }

        }
      }
      await driver.sleep(10000)
      const element = await driver.findElement(By.id('OrderCreateID')).click();
      await driver.wait(until.alertIsPresent(), 10000);
      const alert = await driver.switchTo().alert();
      await alert.accept();
      if (await this.isAlertPresent(driver)) {
        const alert = await driver.switchTo().alert();
        const alertText = await alert.getText();
        const update = await this.pvhCoLineRepo.update(
          { poNumber: po.po_number, poLine: po.po_line },
          { status: StatusEnum.FAILED, errorMsg: alertText, isActive: false }
        );
        await driver.sleep(3000)
        await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED });
        await alert.accept();
        await driver.sleep(5000)
        await driver.navigate().refresh();
        await driver.quit();
        return new CommonResponseModel(false, 0, alertText)
      } else {
        await driver.sleep(10000)
        await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
        const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
        const coNo = await coNoElement.getAttribute('value');
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
        const year = currentDate.getFullYear().toString().slice(-2);
        const currentDateFormatted = `${day}-${month}-${year}`;
        if (coNo) {
          const update = await this.pvhCoLineRepo.update(
            { poNumber: po.po_number, poLine: po.po_line },
            { coDate: currentDateFormatted, coNumber: coNo, status: 'Success', errorMsg: '-' }
          );
          await driver.sleep(3000)
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.SUCCESS })
          return new CommonResponseModel(true, 1, "COline created successfully");
        } else {
          const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', isActive: false, errorMsg: 'CO Number Not Found' });
          await driver.sleep(3000)
          await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
          await this.getCoLineDataAndSendEmail()
          await driver.sleep(3000)
        }
      }
      return new CommonResponseModel(true, 1, `COline created successfully`)
    }
    catch (err) {
      console.log(err, 'error');
      if (err.message.includes("Error") || err.name.includes("Error") || err.message.includes("NoSuchElementError") || err.name.includes("NoSuchElementError") || err.message.includes("NoSuchWindowError") || err.name.includes("NoSuchWindowError")) {
        const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Open', errorMsg: "-" });
        await driver.sleep(3000)
        await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.OPEN })
        return new CommonResponseModel(false, 0, "CRM Error")
      }
      else if (err.message.includes("StaleElementReferenceError") || err.name.includes("StaleElementReferenceError")) {
        const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Open', errorMsg: "-" });
        await driver.sleep(3000)
        await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.OPEN })
        return new CommonResponseModel(false, 0, "CRM Error")
      }
      else {
        const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: err.message, isActive: false });
        await driver.sleep(3000)
        await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
        return new CommonResponseModel(false, 0, err.message)
      }
    }
    finally {
      driver.quit()
    }
  }

  async isAlertPresent(driver) {
    try {
      await driver.switchTo().alert();
      return true;
    } catch (e) {
      return false;
    }
  }

  async updateCOLineStatus(req: any): Promise<CommonResponseModel> {
    try {
      if (!req.poLine) {
        return new CommonResponseModel(false, 0, 'poLine is undefined');
      }
      const poLines = req.poLine.split(",");
      for (const poLine of poLines) {
        await this.PvhOrdersRepo.update(
          { poNumber: req.poNumber, poLine: poLine.trim() },
          { status: req.status }
        );
      }
      return new CommonResponseModel(true, 1, 'Success');
    } catch (err) {
      return new CommonResponseModel(false, 0, err)
    }
  }

  async jjboss(): Promise<CommonResponseModel> {
    try {
      console.log("jjboss")
      return new CommonResponseModel(true, 1, 'Success');
    }
    catch (error) {
      console.log("Got Error, Dont Worry JJ Boss Will Handle.")
    }
  }

  async getCoLineDataAndSendEmail(): Promise<CommonResponseModel> {
    const formatDate = (date: Date): string => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const todaysDate = formatDate(today);
    // console.log(todaysDate, "Today's Date");
    const response = await this.pvhCoLineRepo.getCoLineData();
    const data = response || [];
    const updatedData = data.map(item => {
      return {
        ...item,
        updated_at: item.updated_at ? new Date(item.updated_at).toISOString().split('T')[0] : null
      };
    });
    // console.log(updatedData, "Updated Records");
    const coLineFailedData = updatedData.filter(item =>
      item.updated_at === todaysDate && item.status === "Failed"
    );
    // console.log(coLineFailedData, `Failed Records On ${todaysDate}`);
    // console.log(coLineFailedData[0], `Failed Records On ${todaysDate} of Object One`);
    if (coLineFailedData.length === 0) {
      return new CommonResponseModel(false, 0, `No Records With Failed Status On ${todaysDate}`);
    }
    if (coLineFailedData.length > 0) {
      const errorMessage = coLineFailedData.map(item => `
        PO Number: ${item.po_number}
        Buyer Name: ${item.buyer_name}
        PO Line: ${item.po_line}
        PLM Style: ${item.plm_style}
        Item No: ${item.item_no}
        CO Number: ${item.co_number}
        CO Date: ${item.co_date}
        Status: ${item.status}
        Message: ${item.error_msg}
        Updated: ${item.updated_at}
      `).join('\n\n');

      let recipientEmail;
      let ccEmails;
      const buyerName = coLineFailedData[0].buyer_name;
      if (buyerName === 'TommyNorthAmerica') {
        recipientEmail = 'santhosh.palaksha@shahi.co.in';
        ccEmails = ['saiprakash.katiki@gmail.com', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com', 'mahendran.swaminathan@shahi.co.in', 'jaswanthpappala3@gmail.com'];
      } else if (buyerName === 'CKNorthAmerica') {
        recipientEmail = 'santhosh.palaksha@shahi.co.in';
        ccEmails = ['saiprakash.katiki@gmail.com', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com', 'yuvaraj.govindasamy@shahi.co.in', 'silambarasan.selvaraj@shahi.co.in', 'suman.saroj@shahi.co.in', 'chithra.durai@shahi.co.in', 'santhosh.palaksha@shahi.co.in', 'jaswanthpappala3@gmail.com'];
      } else if (buyerName === 'CKEurope') {
        recipientEmail = 'santhosh.palaksha@shahi.co.in';
        ccEmails = ['saiprakash.katiki@gmail.com', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com', 'mktgap.unit12@shahi.co.in', 'sravani.shivashankar@shahi.co.in', 'santhosh.palaksha@shahi.co.in', 'jaswanthpappala3@gmail.com'];
      }

      const transporter = nodemailer.createTransport({
        host: 'smtp.gmail.com',
        port: 587,
        secure: false,
        auth: {
          user: 'alerts@schemaxtech.com',
          pass: 'mzep lrqi mczj uezj'
        }
      });

      const mailOptions = {
        from: 'alerts@schemaxtech.com',
        to: recipientEmail,
        cc: ccEmails,
        subject: 'PVH CO Line Failed Status',
        text: `Dear User,\n\n PVH CO Line Data:\n\n${errorMessage}\n\nRegards,\nPVH BOT`,
      };

      await transporter.sendMail(mailOptions);
      return new CommonResponseModel(true, 1, "Email Sent Successfully");
    } else {
      return new CommonResponseModel(false, 0, "No Records with Failed status and matching submit date");
    }
  }

  /* ASSORTED LOGIC ON 18-12-2024 j2 */
  // else if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
  //   console.log(dest.colors, "color")
  //   console.log(dest.colors[0].sizes[0], "sizes")

  //   await driver.executeScript('arguments[0].click();', tab);

  //   const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
  //   const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;


  //   // parent div ids
  //   /**
  //    * to read sizes : nameDiv1359QZD001
  //    * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
  //    * to read input fields: percentageDiv1359QZD001
  //    * 
  //    */
  //   const allSizes = [];
  //   console.log('---------------------------------------------------------------');
  //   await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
  //   console.log("Read");


  //   // -----------------------   SIZES Reading from UI logic start ---------------
  //   // read all the sizes from the DOM
  //   let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
  //   const totalElements = labelElements?.length;
  //   console.log('Total elements : ' + totalElements);
  //   labelElements.forEach(async r => {
  //     const label = (await r.getText()).trim().toUpperCase().toString();
  //     allSizes.push(label);
  //   });
  //   // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
  //   let i = 1;
  //   while (i <= 10) {
  //     // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
  //     const toJump = Math.min(i * 8, totalElements);
  //     const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
  //     // scroll the pointer to right side
  //     driver.executeScript("arguments[0].scrollIntoView()", rightEle);
  //     driver.sleep(1000);
  //     // read all the visible sizes from the DOM
  //     let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
  //     // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
  //     console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
  //     currentUserVisbileElements.forEach(async (r, index) => {
  //       if (allSizes[index] == '') {
  //         console.log(index, "index");
  //         const label = (await r.getText()).trim().toUpperCase().toString();
  //         allSizes[index] = label;
  //       }
  //     });
  //     console.log(allSizes);
  //     i++;
  //   }
  //   // construct a reverse mapping of size => column location for easy scrolling during qty input
  //   const sizeToDisplayRowColumnIndex = [];
  //   allSizes.forEach((size, i) => {
  //     sizeToDisplayRowColumnIndex[size] = i;
  //   })
  //   // -----------------------   SIZES Reading from UI logic END ---------------
  //   // ---------------------- COLOR GETTING LOGIC START -------------------------
  //   const colorsInTable = [];
  //   const colorsToDisplayRowColumnIndex = [];
  //   // get the total colors for the current PO from the UI
  //   const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
  //   console.log('total colors : ' + totalColorElements.length);
  //   let cc = 0;
  //   for (const r of totalColorElements) {
  //     // console.log("plesessssssssssssssssss")
  //     // scroll to the specific location in the screen to read the color 
  //     const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
  //     // execute the scroll command
  //     await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
  //     await driver.sleep(500);
  //     // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
  //     const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
  //     // console.log(sepcificRowColorEle, "sepcificRowColorEle");
  //     const displayingColor = (await sepcificRowColorEle[0]?.getText());
  //     // push the color to an array
  //     colorsInTable.push(displayingColor);
  //     cc++;
  //   }

  //   // now reverse map the color -> exact row index in the DOM
  //   colorsInTable.forEach((color, index) => {
  //     colorsToDisplayRowColumnIndex[color] = index;
  //   });
  //   // ---------------------- COLOR GETTING LOGIC END -------------------------

  //   //  console.log("ppppppppppppppp")
  //   for (let [colorIndex, color] of dest.colors.entries()) {
  //     // for this specific color, scroll the window to the specific row where the color is visible
  //     const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
  //     if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
  //       // break;
  //       const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found ${color.name}`, isActive: false });
  //       await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
  //       // driver.quit()
  //       return new CommonResponseModel(false, 0, 'No Matching Color Found')
  //     }
  //     const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
  //     driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
  //     driver.sleep(500);
  //     try {
  //       const saleInput = `${color.name.toUpperCase().toString().trim()}ASSORTED`;
  //       console.log(saleInput, "saleInput")
  //       const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
  //       await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
  //     } catch (error) {
  //       console.error("Error finding sale price input:", error);
  //       const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: `NO matching Color found ${color.name}`, isActive: false });
  //       await this.updateCOLineStatus({ poNumber: po.po_number, poLine: po.po_line, status: StatusEnum.FAILED })
  //       // driver.quit()
  //       return new CommonResponseModel(false, 0, 'No Matching Color Found')
  //     }
  //     for (let [sizeIndex, size] of color.sizes.entries()) {
  //       let matchedSize = null;
  //       if (colorIndex >= 0) {
  //         // Find all the labels in the second row.
  //         await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
  //         let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
  //         const fileteredElements: any[] = [];
  //         for (const labelElement of labelElements) {
  //           const ele = (await labelElement.getText())?.trim();
  //           ele.length > 0 ? fileteredElements.push(labelElement) : '';
  //         }
  //         let tabIndex = 1;
  //         const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
  //         const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
  //         await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
  //         const dropdown = await driver.findElement(By.id(`bydline/${string}`));
  //         const options = await dropdown.findElements(By.tagName('option'));
  //         const optionValues = [];
  //         for (const option of options) {
  //           const value = await option.getAttribute('value');
  //           optionValues.push(value);
  //         }
  //         const number = optionValues.find(value => {
  //           return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
  //         });
  //         console.log(number, "nummmm")
  //         // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
  //         await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
  //         // Find all the input fields in the first row.
  //         const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
  //         // Create a map of size labels to input fields.
  //         const sizeToInputMap = {};
  //         for (let i = 0; i < fileteredElements.length; i++) {
  //           const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
  //           console.log(label, "labellabellabel")
  //           if (label.length)
  //             sizeToInputMap[label] = inputElements[i];
  //         }
  //         // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
  //         // console.log(size.name, "ssssssssssss")
  //         // const labelNames = Object.keys(sizeToInputMap);
  //         // const sizeNameVariants = size.name.trim().toUpperCase().split(',').map(val => val.trim());  // Split comma-separated values into an array             
  //         // console.log(labelNames, "labelNames")
  //         // console.log(sizeNameVariants, "ssssssssssss")

  //         // if (inputField) {
  //         //   // Clear the existing value (if any) and fill it with the new price.
  //         //   await inputField.clear();
  //         //   await inputField.sendKeys(size.price);
  //         // } else {
  //         //   const update = await this.pvhCoLineRepo.update({ poNumber: po.po_number, poLine: po.po_line }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
  //         //   await this.updateCOLineStatus({ poNumber: po.po_number, lineItemNo: po.po_line, status: StatusEnum.FAILED })
  //         //   return new CommonResponseModel(false, 0, 'NO Matching Size found')
  //         // }
  //         const labelNames = Object.keys(sizeToInputMap);
  //         const sizeNameVariants = size.name.trim().toUpperCase().split(',').map((val) => val.trim());

  //         for (const sizeVariant of sizeNameVariants) {
  //           if (labelNames.includes(sizeVariant)) {
  //             matchedSize = sizeVariant;
  //           }
  //         }
  //         if (matchedSize) {
  //           console.log(matchedSize, "iopiopiop")
  //           const inputField = sizeToInputMap[matchedSize.trim().toUpperCase().toString()];
  //           if (inputField) {
  //             await inputField.clear();
  //             await inputField.sendKeys(size.price);
  //           } else {
  //             await this.pvhCoLineRepo.update(
  //               { poNumber: po.po_number, poLine: po.po_line },
  //               { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
  //             );
  //             await this.updateCOLineStatus({
  //               poNumber: po.po_number,
  //               lineItemNo: po.po_line,
  //               status: StatusEnum.FAILED,
  //             });
  //             return new CommonResponseModel(false, 0, 'No Matching Size Found');
  //           }
  //         } else {
  //           await this.pvhCoLineRepo.update(
  //             { poNumber: po.po_number, poLine: po.po_line },
  //             { status: 'Failed', errorMsg: 'No Matching Size Found', isActive: false }
  //           );
  //           await this.updateCOLineStatus({
  //             poNumber: po.po_number,
  //             lineItemNo: po.po_line,
  //             status: StatusEnum.FAILED,
  //           });
  //           return new CommonResponseModel(false, 0, 'No Matching Size Found');
  //         }
  //       }
  //       const inputId = `${matchedSize}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
  //       console.log(inputId, "ppppp")
  //       const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
  //       await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
  //     }
  //   }
  // }
}


